import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_stock_take_starting_balance: { message: "idle" },
};

export const retrieve_tenant_stock_take_starting_balance_Slice = createSlice({
 name: "retrieve_tenant_stock_take_starting_balance",
 initialState,
 reducers: {
  success_retrieve_tenant_stock_take_starting_balance: (state, action) => {
   state.retrieve_tenant_stock_take_starting_balance = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_stock_take_starting_balance: (state, action) => {
   state.retrieve_tenant_stock_take_starting_balance = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_stock_take_starting_balance: (state) => {
   state.retrieve_tenant_stock_take_starting_balance = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_stock_take_starting_balance: (state) => {
   state.retrieve_tenant_stock_take_starting_balance = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_stock_take_starting_balance, fail_retrieve_tenant_stock_take_starting_balance, reset_retrieve_tenant_stock_take_starting_balance, loading_retrieve_tenant_stock_take_starting_balance } = retrieve_tenant_stock_take_starting_balance_Slice.actions;

export default retrieve_tenant_stock_take_starting_balance_Slice.reducer;